module.exports = __webpack_public_path__ + "img/Pierce2.0178960d.jpg";